import { HTMLAttributeAnchorTarget } from 'react';
import { Link } from 'react-router-dom';
import { CSSProperties } from 'styled-components';

type Props = {
  uri: any;
  identificador: string | number;
  style?: CSSProperties;
  target?: HTMLAttributeAnchorTarget;
  sistema?: string;
};

const CustomLink = ({
  identificador,
  uri,
  style,
  target = '_blank',
  sistema = undefined
}: Props) => {
  const children = (
    <>
      {identificador}&nbsp;&nbsp;
      <i className="fas fa-external-link-alt blue-40" />
    </>
  );

  const rel = 'noopener noreferrer';

  if (sistema) {
    const isLocalHost = ['localnet', 'cloudnet', 'localhost'].some(env =>
      window?.location?.hostname?.includes(env)
    );

    let prefix = '';
    if (isLocalHost) {
      prefix =
        window.location.hostname.toLowerCase() === 'localhost'
          ? 'https://elotech.dev.elotech.com.br'
          : `https://${window.location.hostname
              .replace('localnet.', '')
              .replace('cloudnet.', '')}`;
    }

    return (
      <a
        href={`${prefix}/${sistema}/${uri.replace(/^\//, '')}`}
        target={target}
        rel={rel}
        style={style as any}
      >
        {children}
      </a>
    );
  }
  return (
    <Link target={target} rel={rel} to={uri} style={style as any}>
      {children}
    </Link>
  );
};

export { CustomLink };
